
import Thorchain from "../../../assets/outline/Thorchain.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ThorchainIcon({ className, dataTestid = "ThorchainIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Thorchain data-testid={dataTestid} className={classes} {...rest} />
  );
}
